import { render, staticRenderFns } from "./importPayrollData.vue?vue&type=template&id=681d2a2d&scoped=true"
import script from "./importPayrollData.vue?vue&type=script&lang=js"
export * from "./importPayrollData.vue?vue&type=script&lang=js"
import style0 from "./importPayrollData.vue?vue&type=style&index=0&id=681d2a2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d2a2d",
  null
  
)

export default component.exports